export default "__VITE_ASSET__DvAgHPnp__"